import React, { useState, useRef, useEffect } from 'react';
import { useCurrency } from '../../contexts/CurrencyContext';

const CurrencySwitcher = () => {
    const { selectedCurrency, setSelectedCurrency, getAvailableCurrencies, getCurrentCurrencyInfo } = useCurrency();
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const currencies = getAvailableCurrencies();
    const currentCurrency = getCurrentCurrencyInfo();

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleCurrencyChange = (currencyCode) => {
        setSelectedCurrency(currencyCode);
        setIsOpen(false);
    };

    return (
        <div className="relative" ref={dropdownRef}>
            <button
                onClick={() => setIsOpen(!isOpen)}
                className="flex items-center space-x-2 px-3 py-2 text-sm font-medium text-white bg-black/20 hover:bg-black/30 rounded-lg border border-white/10 hover:border-white/20 transition-all duration-200"
                aria-label="Select currency"
            >
                <span className="text-lg">{currentCurrency.symbol}</span>
                <span className="hidden sm:inline">{selectedCurrency}</span>
                <svg
                    className={`w-4 h-4 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
            </button>

            {isOpen && (
                <div className="absolute left-0 mt-2 bg-white rounded-lg shadow-lg border border-gray-200 z-50 max-h-96 overflow-y-auto" style={{ minWidth: '192px', width: '192px' }}>
                    <div className="py-2">
                        <div className="px-4 py-2 text-xs font-semibold text-gray-500 uppercase tracking-wide border-b border-gray-100">
                            Select Currency
                        </div>
                        {currencies.map((currency) => (
                            <button
                                key={currency.code}
                                onClick={() => handleCurrencyChange(currency.code)}
                                className={`w-full px-4 py-1.5 text-left flex items-center justify-between hover:bg-gray-50 transition-colors duration-150 ${selectedCurrency === currency.code
                                    ? 'bg-purple-50 text-purple-700'
                                    : 'text-gray-700'
                                    }`}
                            >
                                <div className="flex items-center space-x-4">
                                    <span className="text-xs font-medium w-6">{currency.symbol}</span>
                                    <div className="min-w-0 flex-1">
                                        <div className="text-xs font-medium">{currency.code}</div>
                                        <div className="text-[10px] text-gray-500">{currency.name}</div>
                                    </div>
                                </div>
                                {selectedCurrency === currency.code && (
                                    <svg
                                        className="w-5 h-5 text-purple-600"
                                        fill="currentColor"
                                        viewBox="0 0 20 20"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                            clipRule="evenodd"
                                        />
                                    </svg>
                                )}
                            </button>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default CurrencySwitcher; 